import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PageComponent, CrowdctrlListComponent, LoadingCardComponent } from '@crowdctrl/shared';
import { TenantSelectionService } from '@crowdctrl/shared';
import { TenantService } from '@crowdctrl/shared';
import { IonItem, IonLabel, IonThumbnail } from '@ionic/angular/standalone';

@Component({
  selector: 'app-tenant-selection',
  standalone: true,
  imports: [
    PageComponent,
    IonItem,
    IonLabel,
    CrowdctrlListComponent,
    IonThumbnail,
    LoadingCardComponent,
  ],
  templateUrl: './tenant-selection.component.html',
  styleUrl: './tenant-selection.component.css',
})
export class TenantSelectionComponent implements OnInit {
  pageTitle = 'Select Account';
  availableTenants: Array<{ id: string; name: string }> = [];
  isLoading = true;
  hasLoadedOnce = false; // Track if initial load has completed

  constructor(
    private tenantSelectionService: TenantSelectionService,
    private tenantService: TenantService,
    private router: Router,
  ) {}

  async ngOnInit(): Promise<void> {
    await this.loadTenants();
  }

  async loadTenants(): Promise<void> {
    this.isLoading = true;
    try {
      const tenantIds = await this.tenantSelectionService.getAvailableTenants();

      if (tenantIds && tenantIds.length > 0) {
        const tenantPromises = tenantIds.map(async (id) => {
          try {
            const response = await this.tenantService.getTenant(id).toPromise();
            if (response && response.tenant) {
              return { id: response.tenant.id, name: response.tenant.name };
            }
            return null;
          } catch (error) {
            console.error(`Error loading tenant ${id}:`, error);
            return null;
          }
        });

        const tenants = await Promise.all(tenantPromises);
        this.availableTenants = tenants.filter((t) => t !== null) as Array<{
          id: string;
          name: string;
        }>;

        const selectedTenantId = await this.tenantSelectionService.ensureSelectedTenant(tenantIds);
        if (selectedTenantId) {
          this.router.navigate(['/']);
          return;
        }
      }
      this.hasLoadedOnce = true; // Mark that initial load has completed
    } catch (error) {
      console.error('Error loading tenants:', error);
      this.hasLoadedOnce = true; // Mark as loaded even on error
    } finally {
      this.isLoading = false;
    }
  }

  async selectTenant(tenantId: string): Promise<void> {
    await this.tenantSelectionService.setSelectedTenantId(tenantId);
    this.router.navigate(['/']);
  }
}
